import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'antd';
import { casURL, baseURL } from 'util/AppConfig.jsx';

const authURL = casURL + baseURL;

class AuthAlert extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
    };
  }

  onConfirm = () => {
    // TODO: implementare redirect al cas al submit
    // console.log(this.state.modalIsOpen);
    window.location.assign(authURL);
    return;
  }

  openModal = (cause) => {
    this.setState({
      modalIsOpen: true,
      cause,
    });
  }

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
    });
  }

  render() {
    const isOpen = (this.props.userInfo.matricola &&
                    !this.props.isAuthenticated);
    // console.log('debug 3:', this.props.isAuthenticated);
    return (
      <Modal
        title="Sessione scaduta/Non autenticato"
        visible={isOpen}
        maskClosable={false}
        onCancel={() => this.closeModal()}
        footer={[<Button key="back" onClick={this.onConfirm}>Procedi</Button>]}
      >
        <p>Si prega di autenticarsi nuovamente, cliccare su procedi</p>
      </Modal>
    );
  }
}

AuthAlert.propTypes = {
  userInfo: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  hasToken: PropTypes.bool.isRequired,
};

export default AuthAlert;
